module.exports = __webpack_public_path__ + "img/方位映射.6c1e2275.svg";